enum RelatedToArticlePhase {
	NotApplicable = "NotApplicable",
	Ordered = "Ordered",
	Delivered = "Delivered",
	Picked = "Picked"
}

export default RelatedToArticlePhase;